import React from 'react'
import Button, { ButtonProps } from 'shared/Button/Button'

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = '',
  ...args
}) => {
  return (
    <Button
      className={`ttnc-ButtonPrimary disabled:bg-opacity-70  text-neutral-50 ${className}`}
      {...args}
    />
  )
}

export default ButtonPrimary
